module.exports = __webpack_public_path__ + "media/images/v1/cta-bg-875c76ad206045b4161017504b832f0f.png";